/** Format an options expiration string (YYYYMMDD) to a readable date. */
export function formatExpiry(dateStr: string): string {
  if (dateStr.length !== 8) return dateStr;
  const y = dateStr.substring(0, 4);
  const m = dateStr.substring(4, 6);
  const d = dateStr.substring(6, 8);
  const date = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, parseInt(d)));
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}
